module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('family', {
    attrs: {
      "data-obj": _vm.dataObj
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('food', {
    attrs: {
      "data-obj": _vm.dataObj,
      "data-ref": _vm.dataRef
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d4f195f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/input.vue
// module id = 144
// module chunks = 0